import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TicketsTableApi } from 'src/app/shared/api-models/admin/tickets-table-api.type';
import { SortConfig } from 'src/app/shared/view-models/sort-config';
import { InstallersView, TicketsTable } from '../_models';
import { TicketSystemService, ViewStateService } from '../_services';

@Component({
	selector: 'ts-installers-table',
	templateUrl: './installers-table.component.html'
})
export class InstallersTableComponent {
	@Input() getSortIconClass: (column: string) => string;
	@Input() sortConfig: SortConfig;
	@Input() tableData: Partial<TicketsTable & InstallersView & TicketsTableApi>[];
	@Input() totalItems: number;
	@Output() handleSortClick: EventEmitter<SortConfig> = new EventEmitter();
	@Output() handlePaginationClick: EventEmitter<number | undefined> = new EventEmitter();

	constructor(private router: Router, public ticketSystemService: TicketSystemService, public viewStateService: ViewStateService) {}

	onRowSelect(installer: Partial<TicketsTable & InstallersView & TicketsTableApi>): void {
		this.router.navigate([`/ticket-system/edit-installer/${installer.Id}`]);
	}
}
